import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConsultationRequestSessionGuard implements CanActivate {
  private router = inject(Router);
  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Determines whether the current route can be activated.
   *
   * @returns {boolean} true if the route can be activated, false otherwise
   */
  public canActivate(): boolean {
    if (
      this.consultationStorageService.transactionId &&
      this.consultationStorageService.hash &&
      this.consultationStorageService.consultationId &&
      this.consultationStorageService.treatmentType
    ) {
      return true;
    }

    this.router.navigateByUrl(
      `/consultation/${this.consultationStorageService.treatmentType || ConsultationTreatmentTypes.Std}/request`,
    );

    return false;
  }
}
